import selectors from './selectors';
import modalView from './modalView';
import updateCartCount from './updateCartCount';
import addResource from './addResource';

const handleAddResource = (event) => {
    const { table, resources, cart } = selectors;
    const { links } = resources;

    event.preventDefault();
    const clicked = event.currentTarget;

    // Close collections drop-down.
    $(table.popup).removeClass('active');

    // Gather inputs.
    const items = $(clicked).parents(links.container).find(links.link);

    items.each((index, el) => {
        const checked = $(el).find(resources.selected);
        if (checked.length) {
            addResource(el);
        }
        updateCartCount();
    });
    if ($(cart.empty).is(':visible') && modalView) {
        // Show the cart screen.
        $(cart.wrapper).show();
        $(cart.empty).hide();
    }
    $(resources.checked).each((i, element) => {
        $(element).prop('checked', false);
    });
};

export default handleAddResource;
